<div class="content-layout" [brightsideWebFb]="{event_name: 'onboarding_welcome'}">
  <bw-action-article-legacy>
    <div pre-title>
      <img src="./assets/onboarding/onboarding-welcome.png" alt="onboarding_welcome" class="mb-md"/>
    </div>
    <div header-title>
      <typography-legacy
      title-large>
        {{ 'ONBOARDING_WELCOME_TITLE' | translate}}
      </typography-legacy>
    </div>
    <div content-section>
      <typography-legacy
        class="mb-sm"
        text-small-regular
        color="var(--secondary-text)">
        {{ 'ONBOARDING_WELCOME_DESC' | translate }}
      </typography-legacy>
      <typography-legacy
        class="mb-sm"
        text-small-semibold>
        {{ 'ONBOARDING_WELCOME_SUBTEXT' | translate }}
      </typography-legacy>
      <div class="flex-row mb-xs">
        <bw-icon-legacy [iconName]="'arrow_right'" class="mr-sm"></bw-icon-legacy>
        <typography-legacy text-xsmall-regular>{{ 'ONBOARDING_WELCOME_ITEM_1' | translate }}</typography-legacy>
      </div>
      <div class="flex-row mb-xs">
        <bw-icon-legacy [iconName]="'arrow_right'" class="mr-sm"></bw-icon-legacy>
        <typography-legacy text-xsmall-regular>{{ 'ONBOARDING_WELCOME_ITEM_2' | translate }}</typography-legacy>
      </div>
      <div class="flex-row mb-xs">
        <bw-icon-legacy [iconName]="'arrow_right'" class="mr-sm"></bw-icon-legacy>
        <typography-legacy text-xsmall-regular>{{ 'ONBOARDING_WELCOME_ITEM_3' | translate }}</typography-legacy>
      </div>
    </div>
    <div footer-actions>
      <button
        bw-button-legacy
        [brightsideWebFb]="{event_name: 'onboarding_welcome'}"
        (click)="advance();">
        {{ 'ONBOARDING_WELCOME_CTA' | translate }}
      </button>
    </div>

  </bw-action-article-legacy>
</div>
